import { createSlice } from '@reduxjs/toolkit'
import { setDarkMode, setEnglish, setFullScreen, setUtc } from '../reducers/appReducers'
export type AppState = {
  isFullScreen: boolean
  isUtc: boolean
  isDarkMode: boolean
  isEnglish: boolean
}

const initialState: AppState = {
  isFullScreen: false,
  isUtc: false,
  isDarkMode: false,
  isEnglish: false,
}

const appSlice = createSlice({
  name: 'app',
  initialState,
  reducers: {
    setFullScreen,
    setUtc,
    setDarkMode,
    setEnglish,
  },
})

export const appActions = appSlice.actions
export default appSlice.reducer
